import React, { useEffect, useState } from "react";
import "./Loader.css";

const Loader = ({ show }) => {
  const [visible, setVisible] = useState(show);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
      setFade(true);
    } else {
      setFade(false);
      const timer = setTimeout(() => setVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [show]);

  if (!visible) return null;

  return (
    <div className={`loader-wrapper ${fade ? "fade-in" : "fade-out"}`}>
      <div className="loader-circle"></div>
    </div>
  );
};

export default Loader;
